import { css } from '../styled';
export const breakpoints = {
    // max-width 1024px are tablet devices
    tablet: 1024,
    // max-width 767px are mobile devices
    mobile: 767,
};
// iterate through the sizes and create a media template
const devices = Object.keys(breakpoints);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const initValue = {};
// eslint-disable-next-line no-underscore-dangle
export const media = devices.reduce((accumulator, label) => {
    // use px in breakpoints to work properly cross-browser and support users
    // changing their browsers font-size: https://zellwk.com/blog/media-query-units/
    const emSize = breakpoints[label];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    accumulator[label] = (first, ...args) => css `
      @media (max-width: ${emSize}px) {
        ${css(first, ...args)};
      }
    `;
    return accumulator;
}, initValue);
export const getSizeKey = (width) => {
    const deviceEntries = Object.entries(breakpoints);
    const target = deviceEntries.find(([, targetWidth]) => width > targetWidth);
    return target ? target[0] : 'mobile';
};
//# sourceMappingURL=breakpoint.js.map